<template>
  <div class="content" style="min-width:800px">
    <n-card :more="true" title="My Resume Infos">
      <div class="resume-content">
        <mavon-editor
          v-model="content.resume"
          :editable="!1"
          :toolbarsFlag="!1"
          :subfield="!1"
          previewBackground="#FFF"
          boxShadowStyle="none"
          defaultOpen="preview"></mavon-editor>
      </div>
    </n-card>
  </div>
</template>
<script>
import nCard from "@/components/profile/nCard.vue";
export default {
  components: {
    nCard
  },
  data() {
    return {
      content: this.mStore.state
    };
  }
};
</script>
<style>
.content {
  width: 400px;
  /* min-height: 300px; */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.content > .ivu-card {
  margin: 5px;
}
.resume-content {
  min-width: 250px;
  min-height: 200px;
  padding-bottom: 25px;
}
.user-content .avatar {
  min-height: 125px;
  min-width: 125px;
}
.ivu-avatar > img {
  border-radius: 50%;
}
.left {
  min-width: 50%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.left .title {
  font-size: 20px;
}
.left .sub-title {
  font-size: 12px;
  color: #2b7cba;
}
.right-form {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-item {
  text-align: left;
  margin-bottom: 10px;
}
.form-item label {
  font-size: 14px;
  color: #ccc;
  display: block;
}
.form-input {
  width: auto;
  margin-right: 5px;
}
.form-input .ivu-input-suffix {
  display: none;
}
.form-item .ivu-input-with-suffix {
  padding-right: 7px;
}
.form-input input.main {
  font-weight: bold;
  font-size: 16px;
}
.form-input input::placeholder,
input::-moz-placeholder,
input::-webkit-input-placeholder {
  font-size: 14px;
  font-weight: none;
}
.form-input .ivu-input {
  border: none;
  border-bottom: 1px solid #dcdee2;
  border-radius: 0px;
  padding-left: 0;
  height: 28px;
}
.form-input .ivu-input:focus {
  /* box-shadow: 0 0 0 2px rgba(45,140,240,.2); */
  box-shadow: none;
  border-bottom: 1px solid rgba(45, 140, 240, 0.2);
  border-radius: 0px;
}
.dev-md-content {
  text-align: start;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/infos-card.vue